<template>
  <div v-if="data.typeMontant === tranche" class="pd-20px">
    <v-client-table v-model="data.tranchesAchat" :columns="columns" :options="options"
                    ref="tranchesAchatArray" class="displayNoneVuePagination">
      <div slot="montantBas" slot-scope="props">
        <b-input v-model="props.row.montantBas" type="number" expanded  v-if="!detail"
                 step="0.01"
                 @input="updateValueTranche(props.index, 'montantBas', $event)"
        ></b-input>
        <span v-else>{{ props.row.montantBas | formatDevise }}</span>
      </div>
      <div slot="montantHaut" slot-scope="props">
        <b-input v-model="props.row.montantHaut" type="number" expanded  v-if="!detail"
                 step="0.01"
                 @input="updateValueTranche(props.index, 'montantHaut', $event)"
        ></b-input>
        <span v-else>{{ props.row.montantHaut | formatDevise }}</span>
      </div>
      <div slot="pourcentageReversement" slot-scope="props">
        <b-input v-model="props.row.pourcentageReversement" type="number" expanded  v-if="!detail"
                 step="0.01"
                 @input="updateValueTranche(props.index, 'pourcentageReversement', $event)"
        ></b-input>
        <span v-else>{{ props.row.pourcentageReversement | formatPercent }}</span>
      </div>
      <div slot="delete" slot-scope="props">
        <a @click="deleteTranche(props.index)">
          <b-icon class="mgt-5px" icon="delete-forever" type="is-danger"></b-icon>
        </a>
      </div>
    </v-client-table>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import { columnsSplice } from '@/services/general/columns';
import { TRANCHE } from '@/configuration/presse/produitSalon/produitSalonConfiguration';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';

export default {
  name: 'CatalogueProduitGeneralPresseEditTranche',
  props: {
    data: Object,
    indexRegle: Number,
    detail: Boolean,
  },
  data() {
    return {
      tranche: TRANCHE,
    };
  },
  computed: {
    columns() {
      const columns = ['montantBas', 'montantHaut', 'pourcentageReversement', 'delete'];
      if (this.detail) {
        columnsSplice(columns, 'delete');
      }
      return columns;
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          montantBas: this.$t('produitSalon.reglesAchat.tranches.montantBas'),
          pourcentageReversement: this.$t('produitSalon.reglesAchat.tranches.pourcentageReversement'),
          montantHaut: this.$t('produitSalon.reglesAchat.tranches.montantHaut'),
          delete: '',
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: texts,
        columnsClasses: {
          delete: 'colonneSelected',
        },
        sortable: [],
      };
    },
  },
  methods: {
    deleteTranche(index) {
      this.$emit('deleteTranche', this.indexRegle, index - 1);
    },
    updateValueTranche(index, variable, value) {
      this.$emit('updateTrancheValue', this.indexRegle, index - 1, variable, value);
    },
  },
};
</script>

<style scoped>

</style>
